export const contactTopics: string[] = [
    "A question about a repair",
    "Advice on a new door",
    "An existing booking",
    "Commercial work",
    "Something else"
]

export const contactLimits = {
    name: 80,
    email: 120,
    phone: 24,
    message: 2000
}

export const contactFaqs: { question: string, answer: string }[] = [
    {
        question: "How fast will you reply?",
        answer: "Messages sent during office hours get a reply the same day, usually within two hours. Anything sent after 6 PM is answered the next morning."
    },
    {
        question: "Can I get a price through this form?",
        answer: "You can ask, but the quote form is quicker. It asks the right questions for your door and gets you a written price range by text, usually within 30 minutes."
    },
    {
        question: "My door is stuck right now. Should I write?",
        answer: "No, call us instead. The emergency line is staffed until 10 PM and a technician can usually be with you the same day."
    }
]
